import * as React from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sell from "../pages/sell/page";
import Finance from "../pages/finance/page";
import Agents from "../pages/agents/page";
import Contact from "../pages/contact/page";
import Blog from "../pages/blog/page";
import Resources from "../pages/resources/page";
import Toolkits from "../pages/toolkits/page";
import Backoffice from "../pages/backoffice/page";
import BookingPage from "../pages/booking/page";
import WorkingOnMyExpTeamBlog from "../pages/blog/working-on-my-exp-team/page";
import FAQ from "../pages/faq/page";
import AZTaxSales from "../pages/az-tax-sales/page";
import AreaPage from "../pages/areas/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sell",
    element: <Sell />,
  },
  {
    path: "/finance",
    element: <Finance />,
  },
  {
    path: "/agents",
    element: <Agents />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/1",
    // Permanent redirect: /blog/1 → canonical slug URL
    element: <Navigate to="/blog/working-on-my-exp-team" replace />,
  },
  {
    path: "/blog/working-on-my-exp-team",
    element: <WorkingOnMyExpTeamBlog />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/az-tax-sales",
    element: <AZTaxSales />,
  },
  {
    path: "/toolkits",
    element: <Toolkits />,
  },
  {
    path: "/backoffice",
    element: <Backoffice />,
  },
  {
    path: "/booking",
    element: <BookingPage />,
  },
  {
    path: "/backoffice/onboarding",
    lazy: async () => {
      try {
        const { default: OnboardingPage } = await import(
          "../pages/backoffice/onboarding/page"
        );
        return { Component: OnboardingPage };
      } catch (err) {
        console.error("Failed to load Onboarding page:", err);
        // Fallback to a simple error component
        return {
          Component: () => (
            <div className="min-h-screen flex items-center justify-center">
              <p>Unable to load the onboarding page.</p>
            </div>
          ),
        };
      }
    },
  },
  {
    path: "/backoffice/tools",
    lazy: async () => {
      try {
        const { default: BackofficeToolsPage } = await import(
          "../pages/backoffice/tools/page"
        );
        return { Component: BackofficeToolsPage };
      } catch (err) {
        console.error("Failed to load Backoffice Tools page:", err);
        return {
          Component: () => (
            <div className="min-h-screen flex items-center justify-center">
              <p>Unable to load the tools page.</p>
            </div>
          ),
        };
      }
    },
  },
  {
    path: "/terms",
    element: (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Terms of Use</h1>
          <p>Coming Soon - Terms and conditions</p>
        </div>
      </div>
    ),
  },
  {
    path: "/privacy",
    element: (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
          <p>Coming Soon - Privacy policy information</p>
        </div>
      </div>
    ),
  },
  {
    path: "/accessibility",
    element: (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Accessibility</h1>
          <p>Coming Soon - Accessibility information</p>
        </div>
      </div>
    ),
  },
  {
    path: "/fair-housing",
    element: (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Fair Housing Statement</h1>
          <p>Coming Soon - Fair housing information</p>
        </div>
      </div>
    ),
  },
  {
    path: "/areas/:city/ca",
    element: <AreaPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
